export interface productDataType {
    productGrade: string,
    productId: number,
    productName: string,
    costPrice: number,
    valueTag: number,
    stock: number,
    selectNum: number 
}

export const column = [
    {
        title: '权益名称',
        dataIndex: 'productName',
        key: 'productName',
    },
    {
        title: '库存',
        dataIndex: 'stock',
        key: 'stock', 
    },
    {
        title: '成本价',
        dataIndex:'costPrice',
        key:'costPrice',  
    },
    {
        title: '权益档次',
        dataIndex:'productGrade',
        key:'productGrade',
        width:100
    }
]